import { RefObject, useLayoutEffect, useState } from 'react';

export const SPACE_CARD_ATTRIBUTE = 'data-space-card';

export const useVisibleItemsHeight = (
  containerRef: RefObject<HTMLElement>,
  totalCount: number,
  visibleCount: number,
): string | undefined => {
  const [maxHeight, setMaxHeight] = useState<string>();

  useLayoutEffect(() => {
    const container = containerRef.current;

    if (!container || totalCount <= visibleCount) {
      setMaxHeight(undefined);
      return;
    }

    const items = container.querySelectorAll<HTMLElement>(`[${SPACE_CARD_ATTRIBUTE}]`);
    const lastVisible = items[visibleCount - 1];

    if (!lastVisible) return;

    const containerTop = container.getBoundingClientRect().top;
    const height = lastVisible.getBoundingClientRect().bottom - containerTop + container.scrollTop;

    setMaxHeight(`${Math.ceil(height)}px`);
  }, [containerRef, totalCount, visibleCount]);

  return maxHeight;
};
